export const highPriorityIconTooltip = "_iuXHd";
export const lowPriorityIconTooltip = "UgwKKc";
export default {highPriorityIconTooltip,lowPriorityIconTooltip};